// Wait for the DOM to be fully loaded before executing the script
document.addEventListener("DOMContentLoaded", function () {
    // Get references to key DOM elements
    const header = document.getElementById("header");
    const dropdownButtons = document.querySelectorAll("[data-dropdown]"); // Navigation dropdown buttons
    const headerButtons = document.querySelectorAll("[data-header-button]"); // Other header buttons
    const headerLogo = document.getElementById("headerLogo"); // Header logo image element

    // Track if user is currently hovering over header
    let isHovering = false;

    /**
     * Updates the header's visual styles based on light/dark mode
     * @param {boolean} isLight - Whether to use light mode styling
     */
    function updateHeaderStyles(isLight) {
        // Toggle white background
        header.classList.toggle("bg-white", isLight);

        // Define which classes to add/remove for buttons
        const buttonActions = {
            add: isLight ? ["text-gray-900"] : ["text-white"], // Dark text for light mode, white for dark
            remove: isLight ? ["text-white"] : ["text-gray-900"] // Remove opposite classes
        };

        // Update all button styles
        [dropdownButtons, headerButtons].forEach(buttons => {
            buttons.forEach(button => {
                button.classList.remove(...buttonActions.remove);
                button.classList.add(...buttonActions.add);
            });
        });

        // Update logo image source if logo exists
        if (headerLogo) {
            // Switch between regular and white logo versions
            headerLogo.src = `/assets/app/public/images/hyundai-elevator${isLight ? "" : "-white"}-logo.svg`;
        }
    }

    /**
     * Updates header styles based on scroll position and hover state
     */
    function updateOnScroll() {
        // Use light mode if scrolled down or at top while hovering
        const shouldBeLight = window.scrollY > 0 || (window.scrollY === 0 && isHovering);
        updateHeaderStyles(shouldBeLight);
    }

    // Handle header hover interactions
    header.addEventListener("mouseenter", () => {
        isHovering = true;
        // Only change styles if at top of page
        if (window.scrollY === 0) {
            updateHeaderStyles(true); // Switch to light mode
        }
    });

    header.addEventListener("mouseleave", () => {
        isHovering = false;
        // Only change styles if at top of page
        if (window.scrollY === 0) {
            updateHeaderStyles(false); // Switch to dark mode
        }
    });

    // Set initial styles and listen for scroll events
    updateOnScroll();
    window.addEventListener("scroll", updateOnScroll);
});
